import Button from '../components/Button';
import { redirectToSSO } from '../utils/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import '../styles/Logout.css';

function AuthError() {
  const params = new URLSearchParams(window.location.search);
  const message = params.get('message');
  const errorMessage = message ? decodeURIComponent(message) : 'Authentication failed';

  return (
    <div className="logout-container" data-testid="auth-error-container">
      <div className="logout-card" data-testid="auth-error-card">
        <div className="logout-icon">
          <FontAwesomeIcon icon={faExclamationTriangle} size="4x" color="#FF6B6B" />
        </div>
        <h2 data-testid="auth-error-heading">Authentication Error</h2>
        <p className="logout-message" data-testid="auth-error-message">
          {errorMessage}
        </p>
        <p className="logout-message" style={{ fontSize: '0.9em', marginTop: '10px' }}>
          Please contact your administrator if you believe you should have access to this
          application.
        </p>
        <Button type="button" onClick={redirectToSSO} size="lg" data-testid="auth-error-retry-btn">
          Try Again
        </Button>
      </div>
    </div>
  );
}

export default AuthError;
